import Text, { TextTag, TEXT_VARIANT } from '@pixum/text';
import Icon from '@pixum/icon';
import styles from './MultiSelectionFallbackContent.module.css';

interface MultiSelectionFallbackContentProps {
  text: string;
}

/**
 * Fallback content rendered inside a ComboBox dropdown when no selectable items are available.
 * Displays an info icon alongside an explanatory text, used for example when the user
 * has no revocable orders or has not yet selected an order in the orders dropdown.
 *
 * @param props.text - Explanatory message to display alongside the info icon
 */
export function MultiSelectionFallbackContent(props: MultiSelectionFallbackContentProps) {
  return (
    <div className={styles.container}>
      <Icon className={styles.icon} name="info" loading="eager" ariaHidden />
      <Text className={styles.text} tag={TextTag.SPAN} variant={TEXT_VARIANT.CAPTION}>
        {props.text}
      </Text>
    </div>
  );
}
